import Session from './session'

export default class KotsuhiAPI {

  static get PREFIX () {
    return Session.HOST + '/api/kotsuhi/'
  }

  /**
   * 交通費登録
   */
  static create (body) {
    const s = new Session()
    return s.ins.post(this.PREFIX + 'create', body)
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
   * 交通費削除
   */
  static delete (id) {
    const s = new Session()
    return s.ins.delete(this.PREFIX + 'delete/' + id)
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
   * 交通費一覧取得
   */
  static getKotsuhiList (params) {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'list', {params: params})
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
   * 未承認の交通費一覧取得
   */
  static getUnapprovedKotsuhiList () {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'list/unapproved')
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
   * 未精算の交通費一覧取得
   */
  static getUnpaidKotsuhiList (userId) {
    const s = new Session()
    var path = 'list/unpaid'
    if(userId) {
      path = path + '?userId=' + userId
    }
    return s.ins.get(this.PREFIX + path)
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
   * 交通費承認
   */
  static confirm (id) {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'confirm/' + id)
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
   * 交通費承認
   */
  static cancel (id) {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'cancel/' + id)
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
   * 年一覧取得
   */
  static getYearList () {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'year/list')
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
   * 交通費ステータス更新
   */
  static updateStatus (status, id) {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'status-update/' + status + '/' + id)
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
   * 交通費ステータス一括更新
   */
  static bulkStatusUpdate (status, data) {
    const s = new Session()
    let body= {
      keyList : data
    }
    return s.ins.post(this.PREFIX + 'status-bulk-update/' + status, body)
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/api/kotsuhi-api.js